'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const ORDER_OVERVIEW = '';
const ORDER_LOOKUP = '/orderlookup';
const CLAIM_DETAILS = '/claim/:id';

exports.CLAIM_DETAILS = CLAIM_DETAILS;
exports.ORDER_LOOKUP = ORDER_LOOKUP;
exports.ORDER_OVERVIEW = ORDER_OVERVIEW;
